<div class="panel-container">
  <div class="sidebar-header">
    <h2>{{panelDetails?.title}}</h2>

    <h2 class="sidebar-close" (click)="closed.emit(false)">&times;</h2>
  </div>
  <div *ngIf="!!panelDetails.filterDetails" class="flex flex-row px-4 py-2 gap-2 items-end justify-end">
    <img src="/assets/filter.svg" (click)="isShowFilters()">
  </div>
  <ng-container *ngIf="showFilters && !!panelDetails.filterDetails">
    <app-side-panel-filter
      [displayFilters]="panelDetails.filterDetails"
      [alertType]="panelDetails.alertType"
      [existingFilterData]="panelDetails.alertFilters"
      >
    </app-side-panel-filter>
  </ng-container>
  <div class="overflow-y-scroll pl-2">
    <ng-container *ngIf="!!panelDetails.headerSection">
      <app-side-panel-table-data
      [rowData]="panelDetails?.panelDetails"
      [headerDetails]="panelDetails.headerSection">
      </app-side-panel-table-data>
    </ng-container>
    <ng-container *ngIf="panelDetails.discrepancies">
      <app-discrepancies
      [discrepancies]="panelDetails.discrepancies"
      ></app-discrepancies>
    </ng-container>
    <ng-container *ngIf="panelDetails.signaturedata">
      <app-mdsignature
      [rowData]="panelDetails.signaturedata"
      >
      </app-mdsignature>
    </ng-container>
  </div>
</div>